// extracted by mini-css-extract-plugin
export var banner = "_g6-0";
export var closeButton = "_g6-2";
export var greenCheckmark = "_g6-3";
export var hereLink = "_g6-4";
export var titleIcon = "_g6-1";